import { cx } from '../../lib/cx';
import type { SpinnerProps } from './types';

/**
 * A loading indicator that announces itself.
 */
export const Spinner = ({ size = 'md', label = 'Cargando' }: SpinnerProps) => (
  <svg
    role="status"
    aria-label={label}
    className={cx('animate-spin text-current', size === 'sm' ? 'h-4 w-4' : 'h-6 w-6')}
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
  </svg>
);
